import { createSlice, PayloadAction } from '@reduxjs/toolkit';



// Define the type for the initial state
export interface AppResponseState {
  api_key: string;
  api_secret: string;
  app_id: string;
  slug: string;
}

// Define initial state
const initialState: AppResponseState = {
  api_key: '',
  api_secret: '',
  app_id: '',
  slug: ''
};

// Create a slice
const appCreatedResponseSlice = createSlice({
  name: 'appCreatedResponse',
  initialState,
  reducers: {
    // Action creator to save the response data
    saveResponseData(state, action: PayloadAction<AppResponseState>) {
      const { api_key, api_secret, app_id, slug } = action.payload;
      state.api_key = api_key;
      state.api_secret = api_secret;
      state.app_id = app_id;
      state.slug = slug;
      localStorage.setItem('slug', slug);
    },
    // Action creator to clear the response data
    clearResponseData(state) {
      state.api_key = '';
      state.api_secret = '';
      state.app_id = '';
      state.slug = '';
      localStorage.removeItem('slug');
    }
  }
});

// Export action creators
export const { saveResponseData, clearResponseData } = appCreatedResponseSlice.actions;

// Export reducer
export default appCreatedResponseSlice.reducer;
